import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsHeatmap from "highcharts/modules/heatmap";

HighchartsHeatmap(Highcharts);

const HeatMap = () => {
	// Substring helper function
	const substr = (s, from, length) => s.substr(from, length);

	const options = {
		chart: {
			type: "heatmap",
			plotBorderWidth: 0,
			height: 300,
			style: {
				fontSize: "14px",
				position: "relative",
			},
		},
		title: {
			text: null,
		},
		credits: {
			enabled: false,
		},
		xAxis: {
			categories: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			],
			opposite: true,
		},
		yAxis: {
			categories: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
			title: null,
			reversed: true,
		},
		accessibility: {
			point: {
				descriptionFormat:
					"{(add index 1)}. " +
					"{series.xAxis.categories.(x)} sales " +
					"{series.yAxis.categories.(y)}, {value}.",
			},
		},
		colorAxis: {
			min: 0,
			stops: [
				[0.1, "#F3F4F7"],
				[0.3, "#ffd3a3"],
				[0.6, "#ff6b28"],
				[1, "#3c140f"],
			],
		},
		legend: {
			enabled: true,
			align: "right",
			layout: "horizontal",
			margin: 0,
			verticalAlign: "bottom",
			y: 25,
			symbolHeight: 20,
		},
		tooltip: {
			pointFormat: "<b>{point.value}</b> Employees on leave <br>",
			style: {
				fontSize: "14px",
			},
		},
		series: [
			{
				name: "Leave",
				borderWidth: 1,
				borderColor: "#FFFFFF",
				data: [
					// X, Y, Value
					[0, 0, 10],
					[0, 1, 19],
					[0, 2, 8],
					[0, 3, 24],
					[0, 4, 67],
					[0, 5, 0],
					[0, 6, 0],
					[1, 0, 92],
					[1, 1, 58],
					[1, 2, 78],
					[1, 3, 117],
					[1, 4, 48],
					[1, 5, 0],
					[1, 6, 0],
					[2, 0, 35],
					[2, 1, 15],
					[2, 2, 123],
					[2, 3, 64],
					[2, 4, 52],
					[2, 5, 0],
					[2, 6, 0],
					[3, 0, 72],
					[3, 1, 132],
					[3, 2, 114],
					[3, 3, 19],
					[3, 4, 16],
					[3, 5, 0],
					[3, 6, 0],
					[4, 0, 38],
					[4, 1, 5],
					[4, 2, 8],
					[4, 3, 117],
					[4, 4, 115],
					[4, 5, 0],
					[4, 6, 0],
					[5, 0, 88],
					[5, 1, 32],
					[5, 2, 12],
					[5, 3, 6],
					[5, 4, 120],
					[5, 5, 0],
					[5, 6, 0],
					[6, 0, 13],
					[6, 1, 44],
					[6, 2, 88],
					[6, 3, 98],
					[6, 4, 96],
					[6, 5, 0],
					[6, 6, 0],
					[7, 0, 31],
					[7, 1, 1],
					[7, 2, 82],
					[7, 3, 32],
					[7, 4, 30],
					[7, 5, 0],
					[7, 6, 0],
					[8, 0, 85],
					[8, 1, 97],
					[8, 2, 123],
					[8, 3, 64],
					[8, 4, 84],
					[8, 5, 0],
					[8, 6, 0],
					[9, 0, 47],
					[9, 1, 114],
					[9, 2, 31],
					[9, 3, 48],
					[9, 4, 91],
					[9, 5, 0],
					[9, 6, 0],
					[10, 0, 105],
					[10, 1, 97],
					[10, 2, 123],
					[10, 3, 64],
					[10, 4, 3],
					[10, 5, 0],
					[10, 6, 0],
					[11, 0, 58],
					[11, 1, 114],
					[11, 2, 25],
					[11, 3, 98],
					[11, 4, 67],
					[11, 5, 0],
					[11, 6, 0],
				],
				dataLabels: {
					enabled: false,
					color: "#000000",
				},
			},
		],
		responsive: {
			rules: [
				{
					condition: {
						maxWidth: 1000,
					},
					chartOptions: {
						yAxis: {
							labels: {
								formatter: function () {
									return substr(this.value, 0, 1); // Shorten day names
								},
							},
						},
						xAxis: {
							labels: {
								formatter: function () {
									return substr(this.value, 0, 3); // Shorten month names
								},
							},
						},
					},
				},
			],
		},
	};

	return (
		<div className="width-full">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default HeatMap;
